import { blocked, failed } from 'flare-chat-core/contracts/chat/operation-result';
import type { ChatActions } from 'flare-chat-core/controller';
import type { ChatState } from 'flare-chat-core/contracts';
import type { MessageSkillCard, SkillProjection, SkillReadOwner } from '../capabilities/contracts';
import { attachCompletedMessageCapabilityActions } from '../../projection/message-action/completedMessageCapabilityActions.js';
import { timelineView } from '../../projection/workspace.js';
import { resolveComposerActionIntent } from './dispatch.js';

const currentCard = (state: ChatState, registry: SkillProjection, entry: MessageSkillCard) => (
  attachCompletedMessageCapabilityActions(timelineView(state), registry, state.session.sessionId)
    .flatMap((item) => item.messageCapabilityActions ?? [])
    .find((card) => card.key === entry?.key && card.prompt === entry.prompt
      && card.sessionId === entry.sessionId && card.skill_id === entry.skill_id
      && card.selected_capability_id === entry.selected_capability_id)
);

/** Check the accepted declaration, then prefill Core's draft without dispatching a Run. */
export const createMessageCapabilityAction = ({ actions, getSnapshot, skills }: {
  actions: Pick<ChatActions, 'setInputValue'>; getSnapshot: () => ChatState; skills?: SkillReadOwner;
}) => (entry: MessageSkillCard) => {
  const sessionId = getSnapshot().session.sessionId;
  if (!sessionId || entry?.sessionId !== sessionId || entry.messageActionSurface !== 'completed_message'
    || !skills?.isCurrent()) return blocked('message_capability_unavailable');
  try {
    const registry = skills.getSnapshot();
    const state = getSnapshot();
    if (registry.status !== 'ready' || !registry.projection || !skills.isCurrent()
      || state.session.sessionId !== sessionId) return blocked('message_capability_unavailable');
    const card = currentCard(state, registry.projection, entry);
    if (!card) return blocked('message_capability_unavailable');
    const intent = resolveComposerActionIntent(card);
    if (intent.kind !== 'prefill') return blocked('message_capability_unavailable');
    return actions.setInputValue(intent.content);
  } catch (error) {
    return failed(error, 'setInputValue');
  }
};
